var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9165 12.5441H4.08317C1.954 12.5441 0.729004 11.3191 0.729004 9.18994V5.10661C0.729004 2.97744 1.954 1.75244 4.08317 1.75244H9.9165C12.0457 1.75244 13.2707 2.97744 13.2707 5.10661V9.18994C13.2707 11.3191 12.0457 12.5441 9.9165 12.5441ZM4.08317 2.62744C2.41484 2.62744 1.604 3.43827 1.604 5.10661V9.18994C1.604 10.8583 2.41484 11.6691 4.08317 11.6691H9.9165C11.5848 11.6691 12.3957 10.8583 12.3957 9.18994V5.10661C12.3957 3.43827 11.5848 2.62744 9.9165 2.62744H4.08317Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.91911C3.26083 9.91911 3.0625 9.72077 3.0625 9.48161V4.81494C3.0625 4.57577 3.26083 4.37744 3.5 4.37744C3.73917 4.37744 3.9375 4.57577 3.9375 4.81494V9.48161C3.9375 9.72077 3.73917 9.91911 3.5 9.91911Z",
    fill: "#3C7AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.58577C5.01083 7.58577 4.8125 7.38744 4.8125 7.14827V4.81494C4.8125 4.57577 5.01083 4.37744 5.25 4.37744C5.48917 4.37744 5.6875 4.57577 5.6875 4.81494V7.14827C5.6875 7.38744 5.48917 7.58577 5.25 7.58577Z",
    fill: "#3C7AF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.91927C5.01083 9.91927 4.8125 9.72094 4.8125 9.48177V8.89844C4.8125 8.65927 5.01083 8.46094 5.25 8.46094C5.48917 8.46094 5.6875 8.65927 5.6875 8.89844V9.48177C5.6875 9.72094 5.48917 9.91927 5.25 9.91927Z",
    fill: "#3C7AF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.83577C8.51083 5.83577 8.3125 5.63744 8.3125 5.39827V4.81494C8.3125 4.57577 8.51083 4.37744 8.75 4.37744C8.98917 4.37744 9.1875 4.57577 9.1875 4.81494V5.39827C9.1875 5.63744 8.98917 5.83577 8.75 5.83577Z",
    fill: "#3C7AF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91911C6.76083 9.91911 6.5625 9.72077 6.5625 9.48161V4.81494C6.5625 4.57577 6.76083 4.37744 7 4.37744C7.23917 4.37744 7.4375 4.57577 7.4375 4.81494V9.48161C7.4375 9.72077 7.23917 9.91911 7 9.91911Z",
    fill: "#3C7AF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 9.91927C8.51083 9.91927 8.3125 9.72094 8.3125 9.48177V7.14844C8.3125 6.90927 8.51083 6.71094 8.75 6.71094C8.98917 6.71094 9.1875 6.90927 9.1875 7.14844V9.48177C9.1875 9.72094 8.98917 9.91927 8.75 9.91927Z",
    fill: "#3C7AF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.91911C10.2608 9.91911 10.0625 9.72077 10.0625 9.48161V4.81494C10.0625 4.57577 10.2608 4.37744 10.5 4.37744C10.7392 4.37744 10.9375 4.57577 10.9375 4.81494V9.48161C10.9375 9.72077 10.7392 9.91911 10.5 9.91911Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.fbc85a60e24b97a39b512ade06a14a2f.svg";
export { ForwardRef as ReactComponent };